"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ALERT_SEMANTIC = void 0;
const ALERT_SEMANTIC = exports.ALERT_SEMANTIC = Object.freeze({
  neutral: 'neutral',
  success: 'success',
  information: 'information',
  warning: 'warning',
  danger: 'danger'
});